import { routes as consultantPaymentRoutes } from "./services/routes";
import { routes as inpatientRoutes } from "./inpatient/routes";
import { routes as morgueRoutes } from "./morgue/routes";
export const routes = (prefix=`auditing`) => [
    {
        name: `${prefix}.auditing-dashboard.index`,
        path: `/${prefix}/auditing-dashboard`,
        component: () => import('./DashBoard.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.auditing-dashboard.index`,
                PageDescription: "Audits - Main DashBoard",
            },
        },
    },
    ...consultantPaymentRoutes(prefix),
    ...inpatientRoutes(prefix),
    ...morgueRoutes(prefix),
];
